import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import Link from 'next/link';
import { PageState } from '@domain/rs/common/PageableRs';
import Pagination from '@components/common/pagination';
import { usePostJobCategories } from '@repository/post/job/usePostJob';
import InfoCardList from './InfoCardList';
import { PostJobCategoryDto } from '@domain/rs/postJob/PostJobCategoryListRs';
import { ContentRouteUrl } from '@utils/routeUtil';

import classnames from 'classnames/bind';
import styles from './infoList.module.scss';
const cx = classnames.bind(styles);

export const PostJobAllCategory: PostJobCategoryDto = {
  iconType: 'ALL',
  name: '전체',
  priority: 0,
  sn: 0,
};

const InfoList = () => {
  const { query } = useRouter();
  const category = query.category as string;

  const { data: postJobCategoryData } = usePostJobCategories();

  // 초기화 시점에 라우터내 쿼리값이 존재하는 경우 해당 값으로 초기값을 설정한다.
  const [currentCategory, setCurrentCategory] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [postCardSns, setPostCardSns] = useState<number[]>([]);
  const [pageInfo, setPageInfo] = useState<PageState | null>(null);

  useEffect(() => {
    if (!postJobCategoryData) return;

    if (currentCategory === 0) {
      setPostCardSns(postJobCategoryData.categorySns);
    } else {
      setPostCardSns([currentCategory]);
    }
  }, [postJobCategoryData, currentCategory]);

  useEffect(() => {
    if (!postJobCategoryData) return;

    const category = query.category;
    const categorySn = Number(category);
    if (isNaN(categorySn) || categorySn < 0 || !postJobCategoryData.categorySns.some((sn) => sn === categorySn)) return;

    setCurrentCategory(categorySn);
  }, [postJobCategoryData, query]);

  if (!postJobCategoryData) return null;

  const tabList = [PostJobAllCategory, ...postJobCategoryData.categories].map((item) => {
    const href = item.sn === 0 ? ContentRouteUrl.INFO_LIST : `${ContentRouteUrl.INFO_LIST}?category=${item.sn}`;
    return (
      <Link href={href} key={item.sn} legacyBehavior>
        <a
          className={cx('tab', { on: currentCategory === item.sn })}
          onClick={() => {
            setCurrentCategory(item.sn);
            setCurrentPage(0);
          }}
          role="button"
        >
          {item.name}
        </a>
      </Link>
    );
  });

  return (
    <div className={cx('infoListWrap')}>
      <div className={cx('tabArea')}>{tabList}</div>
      <div className={cx('infoList')}>
        <InfoCardList page={currentPage} postCardSns={postCardSns} setPageInfo={setPageInfo} category={category} />
      </div>
      <Pagination
        pagesVO={pageInfo}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        isLeftOn={currentPage > 0 ?? false}
        isRightOn={currentPage + 1 < (pageInfo?.totalPages ?? 0) ?? false}
      />
    </div>
  );
};

export default InfoList;
